var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invitees-list-item" },
    [
      _c("AvatarParticipationStatus", {
        attrs: {
          "attendee-is-organizer": false,
          "is-viewed-by-organizer": _vm.isViewedByOrganizer,
          "avatar-link": _vm.avatarLink,
          "participation-status": _vm.attendee.participationStatus,
          "organizer-display-name": _vm.organizerDisplayName,
          "common-name": _vm.commonName
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "invitees-list-item__displayname" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.commonName) + "\n\t")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "invitees-list-item__actions" },
        [
          _vm.isViewedByOrganizer
            ? _c(
                "Actions",
                [
                  _c(
                    "ActionCheckbox",
                    {
                      attrs: { checked: _vm.attendee.rsvp },
                      on: { change: _vm.toggleRSVP }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Send e-mail")) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ActionRadio",
                    {
                      attrs: { name: _vm.radioName, checked: _vm.isChair },
                      on: {
                        change: function($event) {
                          return _vm.changeRole("CHAIR")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Chairperson")) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ActionRadio",
                    {
                      attrs: {
                        name: _vm.radioName,
                        checked: _vm.isRequiredParticipant
                      },
                      on: {
                        change: function($event) {
                          return _vm.changeRole("REQ-PARTICIPANT")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Required participant")) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ActionRadio",
                    {
                      attrs: {
                        name: _vm.radioName,
                        checked: _vm.isOptionalParticipant
                      },
                      on: {
                        change: function($event) {
                          return _vm.changeRole("OPT-PARTICIPANT")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Optional participant")) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ActionRadio",
                    {
                      attrs: {
                        name: _vm.radioName,
                        checked: _vm.isNonParticipant
                      },
                      on: {
                        change: function($event) {
                          return _vm.changeRole("NON-PARTICIPANT")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Non-participant")) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-delete" },
                      on: { click: _vm.removeAttendee }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Remove attendee")) +
                          "\n\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }